import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

const ServiceX360ViewSection = ({ 
    title = "ServiceX 360 View", 
    description = "Deliver end-to-end transformation across customer and employee experience touchpoints.",
    serviceItems
}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    // Har item ke sath uski photo ka path/URL add kiya gaya hai
  

    return (
        <section className="w-full bg-white py-16 lg:py-24 text-left overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-5 sm:px-10 lg:px-[80px]">
                
                {/* Header Section */}
                <div className="max-w-[760px] mb-10 lg:mb-14">
                    <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.2] tracking-tight mb-4">
                        {title}
                    </h2>
                    {description && (
                        <p className="text-[#555555] font-graphik text-[15px] sm:text-[16px] leading-[1.65]">
                            {description}
                        </p>
                    )}
                </div>

                {/* 2-Column Interactive Section */}
                <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
                    
                    {/* Left Column: Interactive List */}
                    <div className="w-full lg:w-1/2 flex flex-col">
                        {serviceItems.map((item, index) => {
                            const isActive = index === activeIndex;
                            return (
                                <div
                                    key={item.id}
                                    onClick={() => setActiveIndex(index)}
                                    className={`group cursor-pointer flex items-center justify-between py-5 lg:py-7 border-b-[2.5px] transition-all duration-300 ${
                                        isActive
                                            ? 'border-[#EA6B24]'
                                            : 'border-[#01386A]/15 hover:border-[#01386A]/40'
                                    }`}
                                >
                                    <div className="flex items-center gap-4">
                                        <span className={`text-[13px] font-sora font-[700] transition-colors duration-300 ${
                                            isActive ? 'text-[#EA6B24]' : 'text-[#01386A]/35'
                                        }`}>
                                            0{index + 1}
                                        </span>
                                        <h3 className={`text-[16px] sm:text-[18px] lg:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                                            isActive ? 'text-[#01386A]' : 'text-[#01386A]/60 group-hover:text-[#01386A]'
                                        }`}>
                                            {item.title}
                                        </h3>
                                    </div>

                                    <ChevronRight
                                        size={22}
                                        className={`transition-all duration-300 transform ${
                                            isActive
                                                ? 'opacity-100 translate-x-0 text-[#EA6B24]'
                                                : 'opacity-0 -translate-x-3 text-gray-300 group-hover:opacity-60'
                                        }`}
                                    />
                                </div>
                            );
                        })}
                    </div>

                    {/* Right Column: Dynamic Description + Image */}
                    <div className="w-full lg:w-1/2 flex flex-col justify-start">
                        
                        {/* Dynamic Description */}
                        <div className="min-h-[85px] mb-6">
                            <p
                                key={activeIndex}
                                className="text-[#49577A] text-[15px] lg:text-[17px] leading-[1.65] font-[500] font-graphik animate-fade-in"
                            >
                                {serviceItems[activeIndex].description}
                            </p>
                        </div>

                        {/* Image Container */}
                        <div className="w-full h-[320px] sm:h-[380px] lg:h-[400px] overflow-hidden relative shadow-md">
                            <img
                                key={activeIndex}
                                src={serviceItems[activeIndex].image}
                                alt={serviceItems[activeIndex].title}
                                className="w-full h-full object-cover animate-fade-in"
                            />
                        </div>

                    </div>

                </div>

            </div>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(6px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in {
                    animation: fadeIn 0.4s ease-out forwards;
                }
            `}</style>
        </section>
    );
};

export default ServiceX360ViewSection;